import { apiInstance, gql } from "@/services/httpAdapter";

export async function createSaleSpiffAward({
	spiffDefinitionId,
	spiffSetupId,
	row,
	locationId,
	commissionCycleId,
	payPeriodId = "",
}: Record<string, any>) {
	const query = gql`
        mutation createSaleSpiffAward($locationId: String!, $input: SaleSpiffAwardInput!) {
            createSaleSpiffAward(locationId: $locationId, input: $input) {
                _id
                locationId
                commissionCycleId
                spiffSetup {
                    _id
                }
                spiffItem {
                    _id
                }
                recipient {
                    _id
                    fullName
                }
                awards {
                    _id
                    spiffEntry
                    spiffDate
                    spiffType
                    deals {
                        stockNumber
                        dealNumber
                    }
                    reward
                    createdAt
                    updatedAt
                }
            }
        }
    `;

	const awardItem = {
		spiffDate: row.spiffDate,
		spiffType: row.spiffType,
		spiffItemName: row.spiffItemName,
		updatedBy: row.updatedBy,
		createdBy: row.createdBy,
		reward: +row.reward,
		deals: row.deals,
	};

	const input = {
		commissionCycleId,
		payPeriodId,
		spiffSetup: spiffSetupId,
		spiffItem: spiffDefinitionId,
		recipient: row.recipient,
		awards: [awardItem],
	};

	const variables = {
		locationId,
		input,
	};

	const response = await apiInstance.post("/graphql", { query, variables });
	return response?.data?.data?.createSaleSpiffAward;
}

export async function updateSaleSpiffAward({ awardId, locationId, spiffDefinitionId, row, commissionCycleId }: Record<string, any>) {
	const query = gql`
		mutation updateSaleSpiffAward($locationId: String!, $awardId: String!, $input: SaleSpiffAwardInput!) {
			updateSaleSpiffAward(locationId: $locationId, awardId: $awardId, input: $input) {
				_id
				locationId
				commissionCycleId
				spiffSetup {
					_id
				}
				spiffItem {
					_id
				}
				recipient {
					_id
					fullName
				}
				awards {
					_id
					spiffEntry
					spiffDate
					spiffType
					deals {
						stockNumber
						dealNumber
					}
					reward
					createdAt
					updatedAt
				}
			}
		}
	`;

	const awardItem = {
		spiffDate: row.spiffDate,
		reward: +row.reward,
		deals: row.deals,
	};

	const input = {
		commissionCycleId,
		spiffItem: spiffDefinitionId,
		recipient: row.recipient,
		awards: [awardItem],
	};

	const variables = {
		locationId,
		awardId,
		input,
	};

	const response = await apiInstance.post("/graphql", { query, variables });
	return response?.data?.data?.updateSaleSpiffAward;
}

export async function deleteSaleSpiffAward({ locationId, awardIds }: Record<string, any>) {
	const query = gql`
		mutation deleteSaleSpiffAward($locationId: String!, $awardIds: [String]!) {
			deleteSaleSpiffAward(locationId: $locationId, awardIds: $awardIds) {
				_id
				locationId
				commissionCycleId
				spiffSetup {
					_id
				}
				spiffItem {
					_id
				}
				awards {
					_id
				}
			}
		}
	`;

	const variables = {
		locationId,
		awardIds,
	};

	const response = await apiInstance.post("/graphql", { query, variables });
	return response.data.data?.deleteSaleSpiffAward;
}

export async function createServiceSpiffAward({
	spiffDefinitionId,
	spiffSetupId,
	row,
	locationId,
	commissionCycleId,
	payPeriodId = "",
}: Record<string, any>) {
	const query = gql`
        mutation createServiceSpiffAward($locationId: String!, $input: ServiceSpiffAwardInput!) {
            createServiceSpiffAward(locationId: $locationId, input: $input) {
                _id
                locationId
                commissionCycleId
                spiffSetup {
                    _id
                }
                spiffItem {
                    _id
                }
                recipient {
                    _id
                    fullName
                }
                awards {
                    _id
                    spiffEntry
                    spiffDate
                    spiffType
                    repairOrders {
                        vinNumber
                        repairOrderNumber
                    }
                    reward
                    createdAt
                    updatedAt
                }
            }
        }
    `;

	const awardItem = {
		spiffDate: row.spiffDate,
		spiffType: row.spiffType,
		spiffItemName: row.spiffItemName,
		updatedBy: row.updatedBy,
		createdBy: row.createdBy,
		reward: +row.reward,
		repairOrders: row.repairOrders,
	};

	const input = {
		commissionCycleId,
		payPeriodId,
		spiffSetup: spiffSetupId,
		spiffItem: spiffDefinitionId,
		recipient: row.recipient,
		awards: [awardItem],
	};

	const variables = {
		locationId,
		input,
	};

	const response = await apiInstance.post("/graphql", { query, variables });
	return response?.data?.data?.createServiceSpiffAward;
}

export async function updateServiceSpiffAward({ awardId, locationId, spiffDefinitionId, row, commissionCycleId }: Record<string, any>) {
	const query = gql`
		mutation updateServiceSpiffAward($locationId: String!, $awardId: String!, $input: ServiceSpiffAwardInput!) {
			updateServiceSpiffAward(locationId: $locationId, awardId: $awardId, input: $input) {
				_id
				locationId
				commissionCycleId
				spiffSetup {
					_id
				}
				spiffItem {
					_id
				}
				recipient {
					_id
					fullName
				}
				awards {
					_id
					spiffEntry
					spiffDate
					spiffType
					repairOrders {
						vinNumber
						repairOrderNumber
					}
					reward
					createdAt
					updatedAt
				}
			}
		}
	`;

	const awardItem = {
		spiffDate: row.spiffDate,
		reward: +row.reward,
		repairOrders: row.repairOrders,
	};

	const input = {
		commissionCycleId,
		spiffItem: spiffDefinitionId,
		recipient: row.recipient,
		awards: [awardItem],
	};

	const variables = {
		locationId,
		awardId,
		input,
	};

	const response = await apiInstance.post("/graphql", { query, variables });
	return response?.data?.data?.updateServiceSpiffAward;
}

export async function deleteServiceSpiffAward({ locationId, awardIds }: Record<string, any>) {
	const query = gql`
		mutation deleteServiceSpiffAward($locationId: String!, $awardIds: [String]!) {
			deleteServiceSpiffAward(locationId: $locationId, awardIds: $awardIds) {
				_id
				locationId
				commissionCycleId
				spiffSetup {
					_id
				}
				spiffItem {
					_id
				}
				awards {
					_id
				}
			}
		}
	`;

	const variables = {
		locationId,
		awardIds,
	};

	const response = await apiInstance.post("/graphql", { query, variables });
	return response.data.data?.deleteServiceSpiffAward;
}
